import React from 'react';
export function AuthoritySection() {
  return <section className="py-16 px-4 bg-brand-card/30 border-y border-white/5" data-id="element-27">
      <div className="max-w-3xl mx-auto text-center" data-id="element-28">
        <span className="text-5xl mb-4 block" data-id="element-29">👤</span>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10" data-id="element-30">
          Esto no es teoría
        </h2>

        <div className="glass-card rounded-2xl p-8 mb-8 text-left" data-id="element-31">
          <p className="text-xl text-gray-200 mb-6 font-medium text-center" data-id="element-32">
            Este sistema ya ha ayudado a profesores a:
          </p>

          <ul className="space-y-4 max-w-xl mx-auto" data-id="element-33">
            {['Pasar de clases sueltas a ingresos estables', 'Cobrar más por su conocimiento', 'Dejar de depender de su tiempo'].map((item, i) => <li key={i} className="flex items-center bg-brand-dark/50 p-4 rounded-xl border border-white/5" data-id="element-34">
                <span className="text-brand-gold mr-4 text-xl" data-id="element-35">⭐</span>
                <span className="text-lg text-white" data-id="element-36">{item}</span>
              </li>)}
          </ul>
        </div>

        <p className="text-gray-400 italic text-lg" data-id="element-37">
          (No importa si estás empezando o ya tienes experiencia enseñando
          italiano)
        </p>
      </div>
    </section>;
}